import { ENTRY_SCALE_LEVELS } from 'common/variables';


/* ENTRY ACTIONS
================================================================================================ */
export const ENTRY_ZOOM_IN = 'crowdspring/portfolio/ENTRY_ZOOM_IN';
export const ENTRY_ZOOM_OUT = 'crowdspring/portfolio/ENTRY_ZOOM_OUT';
export const ENTRY_RESET_ZOOM = 'crowdspring/portfolio/ENTRY_RESET_ZOOM';
export const SET_ENTRY_PAGE = 'crowdspring/portfolio/SET_ENTRY_DETAILS_PAGE';


/* INITIAL STATES
================================================================================================ */
export const singleEntryInitialState = {
  scaleLevel: 4,
  zoom: 1,
  maxScale: ENTRY_SCALE_LEVELS,
  currentPage: 0,
};


/* HELPERS
================================================================================================ */
export const getEntryModalState = (state) => state.profile.portfolio.portfolioEntry;


/* REDUCERS
================================================================================================ */
export default function reducer(state = singleEntryInitialState, action) {
  switch (action.type) {
    case SET_ENTRY_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case ENTRY_ZOOM_IN:
      if (state.scaleLevel < state.maxScale) {
        const newScale = state.scaleLevel + 1;
        const zoom = newScale * 0.25;
        return {
          ...state,
          zoom,
          scaleLevel: newScale,
        };
      }
      return state;
    case ENTRY_ZOOM_OUT:
      const newScale = state.scaleLevel - 1;
      if (Math.max(newScale, 0)) {
        const zoom = newScale * 0.25;
        return {
          ...state,
          zoom,
          scaleLevel: newScale,
        };
      }
      return state;
    case ENTRY_RESET_ZOOM:
      const defaultState = { ...singleEntryInitialState };

      return {
        ...state,
        scaleLevel: defaultState.scaleLevel,
        zoom: defaultState.zoom,
      };
    default:
      return state;
  }
}


/* ACTION CREATORS
================================================================================================ */
export const zoomInEntry = () => (
  {
    type: ENTRY_ZOOM_IN,
  }
);

export const zoomOutEntry = () => (
  {
    type: ENTRY_ZOOM_OUT,
  }
);

export const resetZoom = () => (
  {
    type: ENTRY_RESET_ZOOM,
  }
);

export const setEntryDetailsPage = (pageNum) => (dispatch) => {
  dispatch({
    type: SET_ENTRY_PAGE,
    payload: pageNum,
  });

  return Promise.resolve(true);
};



// WEBPACK FOOTER //
// ./profile/ducks/portfolio_entry.jsx